import { useEffect, useState } from "react";
import { requiredValidator } from '../../../../utils/validators';
import { FormInput } from "../../components/form-input";
import { useFetch } from "../../../../hooks/useFetch";
import { Icon } from "../../../../components/icon";

import Arrow from "../../../../assets/icons/arrow-right.svg";
import Loading from "../../../../assets/icons/loading.svg"

export const Regulatorio = ({ nextStep, prevStep }) => {
    const [formData, setFormData] = useState({
        natureza: [],
        movimentacao: "",
        produtos: "",
        clientes: "",
        instituicoes: "",
    });
    const [regulatory,setRegulatory]=useState(null);
    const {data, isLoading, error} = useFetch((localStorage.getItem("idEmpresa") !==undefined)? process.env.REACT_APP_API_URL+`Get_CompanyRegulatory?idEmpresa=${localStorage.getItem("idEmpresa")}` : "")
    


    useEffect(()=> {
        if(data!==undefined && data?.hasError===false){        
            SetInputsData(data.model)
        }
    }, [data])


    function SetInputsData(model){
        formData.movimentacao=model.mais_360?"mais":"menos"
        //formData.natureza_negocios=model.natureza_negocios
        setRegulatory(model.natureza_negocios)
        formData.produtos=model.produtos_servicos
        formData.clientes=model.clientes_atendidos
        formData.instituicoes=model.instituicoes_financeiras_atendidas
        setInputState({
            produtos:true,
            clientes:true,
            instituicoes:true,
            natureza:true,
            movimentacao:true,
        })
    }

    const [isValid, setIsValid] = useState(false);
    const [clickedNatureza, setClickedNatureza] = useState(false)
    const [clickedMovimentacao, setClickedMovimentacao] = useState(false)
    const [inputState, setInputState] = useState({
        produtos:false,
        clientes:false,
        instituicoes:false,
        natureza:false,
        movimentacao:false,
    })

    const handleRadioChange = (e) => {
        updateField("movimentacao",true)
        setFormData((prev) => ({
            ...prev,
            movimentacao: e.target.value
        }));
    };
    const handleTextChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const [loadingSend, setLoadingSend] = useState(false)

    const onSubmit = async (e) => {
        e.preventDefault();
        if(isValid){
            registerRegulatory(e.target); 
        }
        
    };

    const [apiError, setApiError] = useState("")
    
    function registerRegulatory(form){
        var data = JSON.stringify(
            {
                
                "natureza_negocios": regulatory,
                "mais_360": formData.movimentacao === "menos"?false:true,
                "produtos_servicos": form.produtos.value,
                "clientes_atendidos": form.clientes.value,
                "instituicoes_financeiras_atendidas": form.instituicoes.value
              }
        )
        console.log(data)
        setLoadingSend(true);
        fetch(process.env.REACT_APP_API_URL+`Register_CompanyRegulatory?id_empresa=${localStorage.getItem("idEmpresa")}`,
            {
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
                method: "POST",
                body: data,
            })
            .then((response)=>{ 
                response.json().then((json)=>{
                    if(json.hasError===false) {
                        nextStep();
                    }else{
                        setApiError(json.description)
                        setTimeout(() => {setApiError("")}, 1500)
                    }
                    })
            }).finally(() => {setLoadingSend(false);})
    }

    const updateField = (field, state) => {
        setInputState(oldState => {
            const ccpy = { ...oldState }
            ccpy[field] = state;
            return { ...ccpy }
        })

    }

    useEffect(() => {
        if(regulatory == null)
            updateField("natureza",false)
        else updateField("natureza",true)
    }, [regulatory])

    useEffect(() => {
        setIsValid(true);
        for (const v of Object.values(inputState)) {
            if (v === false) {
                setIsValid(false);
                break;
            }
        }
    }, [inputState])

    return (
        <form className='conta-content' onSubmit={onSubmit}>
            <div className='conta-content-section'>
                <h2 className="conta-section-title">Regulatório</h2>
                <p className="conta-section-subtitle">
                    Por questões regulatórias e para oferecer serviços personalizados, precisamos saber algumas informações sobre sua empresa.
                </p>

                <div className="row" style={{ gap: 50, flexWrap: "wrap" }}>
                    <div className="half-div">
                        <h3>Natureza do negócio da empresa</h3>
                        <ul onClick={()=>{setClickedNatureza(true)}}>
                            {[
                                { label: "Comércio exterior", description: "Exportar e/ou importar" },
                                { label: "Capital Brasileiro", description: "(Empréstimos e financiamentos, disponibilidades no exterior, compra e venda de imóveis no exterior, doações, investimentos, lucros e dividendos, outras transferências correntes)" },
                                { label: "Capital Estrangeiro", description: "(Empréstimos e financiamentos, disponibilidades no exterior, compra e venda de imóveis no exterior, doações, investimentos, lucros e dividendos, outras transferências correntes)" },
                                { label: "Serviços Diversos", description: "(Serviços técnicos e profissionais, transações comerciais)" },
                                { label: "Seguros", description: "(Resseguros, prêmios, indenizações e sinistros)" },
                                { label: "Transporte", description: "(Frete na exportação ou importação)" },
                                { label: "Intermediação de pagamentos", description: "(provedores de serviços e-FX, facilitadores de pagamentos internacionais)" },
                                { label: "Agências de viagens e turismo", description: "" }
                            ].map((item,index) => (
                                <li key={item.label}>
                                    <input type="checkbox" onClick={()=>{regulatory===index?setRegulatory(null):setRegulatory(index)}} checked={regulatory===index} />
                                    <p>{item.label} <br /> {item.description}</p>
                                </li>
                            ))}
                        </ul>
                        {(!inputState.natureza && clickedNatureza ) && <p className="error-text">Selecione pelo menos 1 opção.</p>}
                    </div>

                    <div className="half-div">
                        <h3>Perfil da empresa</h3>
                        <p>Anualmente, quanto sua empresa pretende movimentar?</p>
                        <div className="input-group">
                            <span onClick={()=>{setClickedMovimentacao(true)}}>
                                <input type="radio" name="movimentacao" value="menos" onChange={handleRadioChange} checked={formData.movimentacao === "menos"} />
                                <label>Até R$ 360 mil/ano</label>
                            </span>
                            <span onClick={()=>{setClickedMovimentacao(true)}}>
                                <input type="radio" name="movimentacao" value="mais" onChange={handleRadioChange} checked={formData.movimentacao === "mais"} />
                                <label>Acima de R$ 360 mil/ano</label>
                            </span>
                            {(!inputState.movimentacao && clickedMovimentacao ) && <p className="error-text">Selecione pelo menos 1 opção.</p>}
                        </div>
                        

                        <FormInput labelStyle={{fontSize:"0.778rem"}} value={formData.produtos} onChange={handleTextChange} id="produtos" label="Quais os principais produtos e serviços oferecidos pela sua empresa?" type="textarea" validators={[
                            {func:requiredValidator}
                        ]}
                        updateField={updateField}/>
                        <FormInput labelStyle={{fontSize:"0.778rem"}} value={formData.clientes} onChange={handleTextChange} id="clientes" label="Quem são os principais clientes da sua empresa?" type="textarea" validators={[
                            {func:requiredValidator}
                        ]}
                        updateField={updateField}/>
                        <FormInput labelStyle={{fontSize:"0.778rem"}} value={formData.instituicoes} onChange={handleTextChange} id="instituicoes" label="Quais instituições financeiras sua empresa opera para câmbio?" type="textarea" validators={[
                            {func:requiredValidator}
                        ]}
                        updateField={updateField}/>
                        
                    </div>
                </div>
            </div>

            <div className='conta-content-footer'>
                <button type="button" disabled={loadingSend} className='step-button prev-step' onClick={prevStep}>
                    <span className='icon'> <Icon icon={Arrow} size={18} rotation={180} />  </span>
                    <span className="text">Voltar</span>
                </button>
                <div className='divider'></div>
                <button type="submit" disabled={!isValid || loadingSend} className='step-button next-step'>

                    <span className="text">Prosseguir</span>
                    <span className='icon'> <Icon icon={loadingSend ? Loading : Arrow} size={18} /> </span>
                   
                </button>
            </div>
            {apiError !== "" && <div style={{width:"100%", display:"flex", justifyContent:"end", marginTop:"10px"}}> 
                <span style={{color:"red"}}> {apiError} </span>
            </div>}
        </form>
    );
};